<div class="container-fluid print-header">
  <div class="row mb-2">
    <div class="col">
      <div class="content-box py-2">
        <img [src]="'/assets/images/hilti-logo.svg' | assetPath" height="33" width="139" alt="HILTI logo" />
      </div>
    </div>
  </div>
  <div class="row pb-1 border-bottom border-print-gray">
    <div class="col">
      <div class="content-box d-flex justify-content-between align-items-baseline">
        <p class="mb-0">
          <span class="heading-md pe-3 text-dark">{{ pageTitle }}</span>
          <span class="text-dark">{{ generationDate }}</span>
        </p>
      </div>
    </div>
  </div>
</div>
